import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=e2b1604e&scoped=true"
import script from "./Country.vue?vue&type=script&lang=js"
export * from "./Country.vue?vue&type=script&lang=js"
import style0 from "./Country.vue?vue&type=style&index=0&id=e2b1604e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b1604e",
  null
  
)

export default component.exports